import {Component, TemplateRef} from '@angular/core';
import {BsModalRef, BsModalService} from "ngx-bootstrap/modal";
import {RedemptionsService} from "@app/features/redemptions/redemptions.service";
import {NavigationService} from "@shared/services/navigation-service.service";
import {NgxSpinnerService} from "ngx-spinner";
import {ActivatedRoute, Router} from "@angular/router";
import {cloneDeep} from "lodash";
import {VouchersService} from "@app/features/vouchers/vouchers.service";

@Component({
  selector: 'app-vouchers-list',
  templateUrl: './vouchers-list.component.html',
  styleUrls: ['./vouchers-list.component.scss']
})
export class VouchersListComponent {


  public params: any;
  public totalItems: any;
  public totalPages: any;
  public dataList: any;
  public PAGE_PATH = 'vouchers'
  public stateCount: any;
  public stateTotal: any;
  public stateCurrency: any;
  modalRef?: BsModalRef;
  public redeemCode: string = '';
  public redeemDone = false;
  public invalidCode = false;
  public voucherId = '';
  statusList = [
    { value: 'ALL', labelKey: 'store.vouchers.status.all' },
    { value: 'ACTIVE', labelKey: 'common.active' },
    { value: 'INACTIVE', labelKey: 'common.inactive' }
  ];
  inStock = [
    { value: 'ALL', labelKey: 'store.vouchers.stock.all' },
    { value: true, labelKey: 'store.vouchers.stock.in' },
    { value: false, labelKey: 'store.vouchers.stock.out' }
  ];

  constructor(public vouchersService: VouchersService,
              public navigation: NavigationService,
              public spinner: NgxSpinnerService,
              public router: Router,
              private modalService: BsModalService,
              public route: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.spinner.show();
    this.initQueryParamMap();
  }

  public initQueryParamMap() {
    this.route.queryParamMap
      .subscribe((params: any) => {
          this.params = params.params.page ? cloneDeep(params.params) : {
            page: 1,
            srt: 'date',
            srtd: 'desc',
          };
          this.getItems();
        }
      );
  }


  public getItems() {
    this.vouchersService.getVouchers(this.params).subscribe((res: any) => {
      this.dataList = res.data;
      this.totalItems = res.total;
      this.totalPages = Math.ceil(parseInt(res.total.toString()) / 5);
      this.spinner.hide();

    }, error => {
      console.log(error);
      this.spinner.hide();

    });
    this.vouchersService.getVouchersTotal(this.params).subscribe((res: any) => {
      this.stateTotal = res.availableCodes;
      this.stateCount = res.vouchersCount;
    }, error => {
      console.log(error);
    });

  }

  backClick(event: any) {
    this.params.page--;
    this.navigation.refreshPage(this.PAGE_PATH, this.params);
  }

  nextClick(event: any) {
    this.params.page++;
    this.navigation.refreshPage(this.PAGE_PATH, this.params);
  }

  getpickerValues(event: any) {
    this.params.page = 1;
    if (event === 'all') {
      delete this.params.from;
      delete this.params.to;
      this.navigation.refreshPage(this.PAGE_PATH, this.params);
      return;
    }
    if (!event.toString().includes('object') && !event.toString().includes('empty')) {
      if (event.toString().split('|').length > 1) {
        this.params.from = event.toString().split('|')[0];
        this.params.to = event.toString().split('|')[1];
      } else {
        this.params.from = event.toString();
        this.params.to = event.toString();
      }
      this.navigation.refreshPage(this.PAGE_PATH, this.params);
    } else if (event.toString().includes('empty')) {
      delete this.params.from;
      delete this.params.to;
      this.navigation.refreshPage(this.PAGE_PATH, this.params);
    } else {
      delete this.params.from;
      delete this.params.to;
    }
  }

  changeFilter(value: any) {
    if (value !== 'ALL') {
      this.params.status = value;
    } else {
      delete this.params.status;
    }
    this.params.page = 1;
    this.navigation.refreshPage(this.PAGE_PATH, this.params);
  }

  changeStockFilter(value: any) {
    if (value !== 'ALL') {
      this.params.inStock = value;
    } else {
      delete this.params.inStock;
    }
    this.params.page = 1;
    this.navigation.refreshPage(this.PAGE_PATH, this.params);
  }

  doSearchByEnter(val: any) {
    this.params.page = 1;
    this.params.search = val?.target?.value;
    this.navigation.refreshPage(this.PAGE_PATH, this.params);

  }

  doSearchByKeyUp(event: any) {
    this.params.search = event.target.value;
    if (this.params.search.length > 3 && event.key !== 'Enter') {
      this.params.page = 1;
      this.navigation.refreshPage(this.PAGE_PATH, this.params);
    }
    if (this.params.search.length === 0) {
      delete this.params.search;
      this.navigation.refreshPage(this.PAGE_PATH, this.params);
    }
  }

  public goToDetails(voucher: any) {
    localStorage.setItem('targetVoucher', JSON.stringify(voucher))
    this.router.navigate(['/vouchers/' + voucher.id])
  }

  createNewVoucher(id: any) {
    this.router.navigate(['/vouchers/' + id])
  }

  public openGenerate(id: any, template: any, pop: any) {
    this.redeemDone = false;
    this.redeemCode = "";
    this.invalidCode = false;
    pop.hide()
    this.voucherId = id;
    this.modalRef = this.modalService.show(template);

  }

  public generateCode() {
    this.spinner.show();
    this.vouchersService.generateCode(this.voucherId, this.redeemCode).subscribe((res: any) => {
      this.redeemDone = true;
      this.spinner.hide();
    }, error => {
      console.log(error);
    })

  }

  public onDone() {
    this.modalRef?.hide()
    this.navigation.refreshPage(this.PAGE_PATH, this.params);
    this.getItems();


  }
}
